import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/styles";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import Snackbar from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import Drawer from "@material-ui/core/Drawer";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import CloseIcon from "@material-ui/icons/Close";
import MenuIcon from "@material-ui/icons/Menu";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import HomeIcon from "@material-ui/icons/Home";
import AddIcon from "@material-ui/icons/Add";
import AccessibilityNewIcon from "@material-ui/icons/AccessibilityNew";
import StarsIcon from "@material-ui/icons/Stars";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";
import styles from "./styles/NavbarStyles";
import ExportButton from "./ExportButton";
import ContrastChecker from "./ContrastChecker";
import PaletteAccessibilityReport from "./PaletteAccessibilityReport";
import ThemeSwitcher from "./components/ThemeSwitcher";
import ShareIcon from "@material-ui/icons/Share";
import { generateShareUrl } from "./helpers/shareHelpers";

class Navbar extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      format: "hex", 
      open: false,
      shareSnackbarOpen: false,
      accessibilityDialogOpen: false,
      accessibilityView: 'checker', // 'checker' or 'report'
      drawerOpen: false,
      aiAssistantOpen: false,
    };
    this.handleFormatChange = this.handleFormatChange.bind(this);
    this.closeSnackbar = this.closeSnackbar.bind(this);
    this.openAccessibilityDialog = this.openAccessibilityDialog.bind(this);
    this.closeAccessibilityDialog = this.closeAccessibilityDialog.bind(this);
    this.toggleAccessibilityView = this.toggleAccessibilityView.bind(this);
    this.toggleDrawer = this.toggleDrawer.bind(this);
    this.handleBack = this.handleBack.bind(this);
    this.toggleAIAssistant = this.toggleAIAssistant.bind(this);
    this.handleShare = this.handleShare.bind(this);
    this.closeShareSnackbar = this.closeShareSnackbar.bind(this);
  }
  handleFormatChange(e) {
    this.setState({ format: e.target.value, open: true });
    this.props.handleChange(e.target.value);
  }
  closeSnackbar() {
    this.setState({ open: false });
  }
  openAccessibilityDialog() {
    this.setState({ accessibilityDialogOpen: true });
  }
  closeAccessibilityDialog() {
    this.setState({ accessibilityDialogOpen: false });
  }
  toggleAccessibilityView() {
    this.setState(st => ({
      accessibilityView: st.accessibilityView === 'checker' ? 'report' : 'checker'
    }));
  }
  toggleDrawer(open) {
    this.setState({ drawerOpen: open });
  }
  toggleAIAssistant() {
    this.setState(st => ({ aiAssistantOpen: !st.aiAssistantOpen }));
  }
  handleShare() {
    const { palette } = this.props;
    if (palette) {
      // Use original colors if available (not the generated shades)
      const url = generateShareUrl(palette.originalPalette || palette);
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(() => {
          this.setState({ shareSnackbarOpen: true });
        }).catch(err => {
          console.error('Failed to copy share URL:', err);
          window.prompt("Copy this link to share:", url);
        });
      } else {
        window.prompt("Copy this link to share:", url);
      }
    }
  }
  closeShareSnackbar() {
    this.setState({ shareSnackbarOpen: false });
  }
  handleBack() {
    const { history, palette } = this.props;
    if (palette) {
      // If on a single color palette, go back to full palette
      const path = history.location.pathname;
      if (path.includes('/palette/') && path.split('/').length === 4) {
        // Single color palette: /palette/:id/:colorId
        const paletteId = path.split('/')[2];
        history.push(`/palette/${paletteId}`);
      } else {
        // Full palette: /palette/:id
        history.push('/');
      }
    } else {
      history.push('/');
    }
  }
  render() {
    const { level, changeLevel, showSlider, classes, palette, paletteElement, history, hideBrand } = this.props;
    const { format, accessibilityDialogOpen, accessibilityView, drawerOpen } = this.state;
    const isHomePage = history.location.pathname === '/';
    const isPalettePage = history.location.pathname.startsWith('/palette/') && !history.location.pathname.includes('/new');
    
    // Drawer content
    const drawerContent = (
      <div className={classes.drawerContent}>
        <div className={classes.drawerHeader}>
          <h2 className={classes.drawerTitle}>Navigation</h2>
          <IconButton onClick={() => this.toggleDrawer(false)} className={classes.drawerCloseButton}>
            <CloseIcon />
          </IconButton>
        </div>
        <Divider style={{ backgroundColor: '#333' }} />
        <List style={{ padding: 0 }}>
          <ListItem 
            button 
            component={Link} 
            to="/" 
            onClick={() => this.toggleDrawer(false)}
            className={isHomePage ? classes.drawerActiveItem : ''}
            style={{ 
              paddingLeft: '1.5rem',
              paddingRight: '1.5rem',
            }}
          >
            <ListItemIcon style={{ color: isHomePage ? '#64B5F6' : 'inherit', minWidth: '40px', opacity: isHomePage ? 1 : 0.7 }}>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText 
              primary="Home" 
              primaryTypographyProps={{ 
                style: { 
                  color: isHomePage ? '#64B5F6' : 'inherit',
                  fontWeight: isHomePage ? '700' : '400',
                  fontSize: '0.95rem',
                } 
              }}
            />
          </ListItem>
          <ListItem 
            button 
            component={Link} 
            to="/palette/new" 
            onClick={() => this.toggleDrawer(false)}
            style={{ 
              paddingLeft: '1.5rem',
              paddingRight: '1.5rem',
            }}
          >
            <ListItemIcon style={{ minWidth: '40px', opacity: 0.7 }}>
              <AddIcon />
            </ListItemIcon>
            <ListItemText 
              primary="Create Palette" 
              primaryTypographyProps={{ 
                style: { 
                  fontSize: '0.95rem',
                } 
              }}
            />
          </ListItem>
          <ListItem
            button
            onClick={() => {
              this.toggleAIAssistant();
              this.toggleDrawer(false);
            }}
            style={{
              color: '#f5f5f5',
              paddingLeft: '1.5rem',
              paddingRight: '1.5rem',
            }}
          >
            <ListItemIcon style={{ color: '#64B5F6', minWidth: '40px' }}>
              <StarsIcon />
            </ListItemIcon>
            <ListItemText
              primary="AI Assistant"
              primaryTypographyProps={{
                style: {
                  color: '#64B5F6',
                  fontSize: '0.95rem',
                  fontWeight: '500'
                }
              }}
            />
          </ListItem>
          {palette && (
            <>
              <Divider style={{ margin: '0.5rem 0', opacity: 0.1 }} />
              {showSlider && (
                <ListItem style={{ flexDirection: 'column', alignItems: 'flex-start', padding: '1rem 1.5rem' }}>
                  <ListItemText
                    primary={`Shade Level: ${level}`}
                    primaryTypographyProps={{ style: { fontSize: '0.9rem', marginBottom: '0.5rem', fontWeight: 600 } }}
                  />
                  <div style={{ width: '100%', padding: '0 10px' }}>
                    <Slider
                      defaultValue={level}
                      min={100}
                      max={900}
                      step={100}
                      onAfterChange={(val) => {
                        changeLevel(val);
                      }}
                    />
                  </div>
                </ListItem>
              )}
              <ListItem 
                button 
                onClick={() => {
                  this.openAccessibilityDialog();
                  this.toggleDrawer(false);
                }}
                style={{ 
                  paddingLeft: '1.5rem',
                  paddingRight: '1.5rem',
                }}
              >
                <ListItemIcon style={{ minWidth: '40px', opacity: 0.7 }}>
                  <AccessibilityNewIcon />
                </ListItemIcon>
                <ListItemText 
                  primary="Accessibility Checker" 
                  primaryTypographyProps={{ 
                    style: { 
                      fontSize: '0.95rem',
                    } 
                  }}
                />
              </ListItem>
            </>
          )}
        </List>
      </div>
    );

    return (
      <header className={classes.Navbar}>
        {/* Brand area — hidden when a GlobalNav already supplies it. */}
        {!hideBrand && (
          <>
            {/* Mobile Hamburger Menu */}
            <IconButton
              className={classes.menuButton}
              onClick={() => this.toggleDrawer(true)}
              aria-label="Open navigation menu"
            >
              <MenuIcon />
            </IconButton>

            {/* Back Button - Show when not on home page */}
            {!isHomePage && (
              <Tooltip title="Go back" placement="bottom" arrow>
                <IconButton
                  onClick={this.handleBack}
                  className={classes.backButton}
                  aria-label="Go back"
                >
                  <ArrowBackIcon />
                </IconButton>
              </Tooltip>
            )}

            <div className={classes.logo}>
              <Link to='/'>customcolor</Link>
            </div>

            <ThemeSwitcher />

            {/* Breadcrumb - Show on palette pages */}
            {isPalettePage && palette && (
              <div className={classes.breadcrumb}>
                <span className={classes.breadcrumbSeparator}>/</span>
                <span className={classes.breadcrumbText}>{palette.paletteName}</span>
              </div>
            )}
          </>
        )}
        {showSlider && (
          <Tooltip 
            title="Adjust color shade intensity (100=lightest, 900=darkest)" 
            placement="bottom" 
            arrow
          >
            <div className={classes.sliderContainer}>
              <span className={classes.levelLabel}>Level: {level}</span>
              <div className={classes.slider}>
                <Slider
                  defaultValue={level}
                  min={100}
                  max={900}
                  step={100}
                  onAfterChange={changeLevel}
                />
              </div>
            </div>
          </Tooltip>
        )}
        <div className={classes.selectContainer}>
          <Select value={format} onChange={this.handleFormatChange}>
            <MenuItem value='hex'>HEX</MenuItem>
            <MenuItem value='rgb' style={{ display: 'flex' }}>RGB</MenuItem>
            <MenuItem value='rgba'>RGBA</MenuItem>
          </Select>
        </div>
        {palette && (
          <>
            <Tooltip title="AI Assistant & Tips" placement="bottom" arrow>
              <IconButton
                onClick={this.toggleAIAssistant}
                className={classes.iconButton}
                style={{ color: '#64B5F6' }}
              >
                <StarsIcon />
              </IconButton>
            </Tooltip>
            <Tooltip 
              title="Check WCAG accessibility & contrast ratios" 
              placement="bottom" 
              arrow
            >
              <IconButton
                onClick={this.openAccessibilityDialog}
                className={classes.iconButton}
              aria-label="Check WCAG accessibility & contrast ratios"
              >
                <AccessibilityNewIcon />
              </IconButton>
            </Tooltip>
            <Tooltip 
              title="Export palette in multiple formats (CSS, JSON, PNG, etc.)" 
              placement="bottom" 
              arrow
            >
              <span aria-label="Export palette in multiple formats (CSS, JSON, PNG, etc.)">
                <ExportButton 
                  palette={palette} 
                  paletteElement={paletteElement}
                  variant="icon"
                />
              </span>
            </Tooltip>
            <Tooltip title="Copy shareable link" placement="bottom" arrow>
              <IconButton
                onClick={this.handleShare}
                className={classes.iconButton}
                aria-label="Copy shareable link"
              >
                <ShareIcon />
              </IconButton>
            </Tooltip>
          </>
        )}
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          open={this.state.open}
          autoHideDuration={3000}
          message={
            <span id='message-id'>
              Format Changed To {format.toUpperCase()}
            </span>
          }
          onClose={this.closeSnackbar}
          action={[
            <IconButton
              onClick={this.closeSnackbar}
              color='inherit'
              key='close'
              aria-label='close'
            >
              <CloseIcon />
            </IconButton>
          ]}
        />
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          open={this.state.shareSnackbarOpen}
          autoHideDuration={3000}
          message={<span id='share-message-id'>Shareable Link Copied To Clipboard!</span>}
          onClose={this.closeShareSnackbar}
          action={[
            <IconButton
              onClick={this.closeShareSnackbar}
              color='inherit'
              key='close'
              aria-label='close'
            >
              <CloseIcon />
            </IconButton>
          ]}
        />
        
        <Dialog
          open={accessibilityDialogOpen}
          onClose={this.closeAccessibilityDialog}
          maxWidth="lg"
          fullWidth
          PaperProps={{
            style: { backgroundColor: '#121212', minHeight: '80vh' }
          }}
        >
          {palette && (
            accessibilityView === 'checker' ? (
              <ContrastChecker />
            ) : (
              <PaletteAccessibilityReport palette={palette} />
            )
          )}
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            padding: '1rem',
            backgroundColor: '#1a1a1a',
            borderTop: '1px solid #444'
          }}>
            <IconButton onClick={this.toggleAccessibilityView} style={{ color: '#64B5F6' }}>
              {accessibilityView === 'checker' ? 'View Palette Report' : 'View Contrast Checker'}
            </IconButton>
            <IconButton onClick={this.closeAccessibilityDialog} style={{ color: '#aaa' }}>
              <CloseIcon />
            </IconButton>
          </div>
        </Dialog>
        
        {/* Mobile Drawer */}
        <Drawer
          anchor="left"
          open={drawerOpen}
          onClose={() => this.toggleDrawer(false)}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          {drawerContent}
        </Drawer>

        {/* AI Assistant Drawer */}
        <Drawer
          anchor="right"
          open={this.state.aiAssistantOpen}
          onClose={this.toggleAIAssistant}
          classes={{
            paper: classes.drawerPaper,
          }}
        >
          <div className={classes.drawerContent}>
            <div className={classes.drawerHeader}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <StarsIcon style={{ color: '#64B5F6', marginRight: '0.5rem' }} />
                <h2 className={classes.drawerTitle}>AI Assistant</h2>
              </div>
              <IconButton onClick={this.toggleAIAssistant} className={classes.drawerCloseButton}>
                <CloseIcon />
              </IconButton>
            </div>
            <Divider style={{ backgroundColor: '#333' }} />
            <div style={{ padding: '1.5rem', color: '#e0e0e0' }}>
              <Typography variant="subtitle1" style={{ fontWeight: 'bold', color: '#64B5F6', marginBottom: '1rem' }}>
                Design Tips for "{palette?.paletteName || 'Your Palette'}"
              </Typography>

              <div style={{ marginBottom: '1.5rem' }}>
                <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
                  Emotional Vibe
                </Typography>
                <Typography variant="body2" style={{ color: '#aaa' }}>
                  This palette feels professional and calm. The balance of blues suggests trust, making it great for fintech or medical dashboards.
                </Typography>
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
                  AI Suggestion
                </Typography>
                <Typography variant="body2" style={{ color: '#aaa' }}>
                  Consider adding a high-contrast accent color like a warm orange (#FF9800) to draw attention to call-to-action buttons.
                </Typography>
              </div>

              <div style={{ marginBottom: '1.5rem' }}>
                <Typography variant="body2" style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>
                  Contextual Insight
                </Typography>
                <Typography variant="body2" style={{ color: '#aaa' }}>
                  Your palette has a "cool" temperature. It will look best against a dark background (#121212) or a very clean white (#FAFAFA).
                </Typography>
              </div>

            </div>
          </div>
        </Drawer>
      </header>
    );
  }
}
export default withRouter(withStyles(styles)(Navbar));
